/* global UI: nav, mobile sheet, mega, reveal, wishlist, quick-add */

  // nav border on scroll
  const topbar = document.getElementById('topbar');
  const onScroll = () => { topbar.classList.toggle('scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', onScroll, { passive:true });
  onScroll();

  // mobile sheet
  const sheet = document.getElementById('msheet');
  const openSheet = () => { sheet.classList.add('open'); sheet.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; };
  const closeSheet = () => { sheet.classList.remove('open'); sheet.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
  document.getElementById('navToggle').addEventListener('click', openSheet);
  document.getElementById('mclose').addEventListener('click', closeSheet);
  sheet.querySelectorAll('a').forEach(a => a.addEventListener('click', closeSheet));

  // mobile sub-menu accordions (Scarves / Under Scarves / Accessories)
  sheet.querySelectorAll('.msub-head').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });

  // mega menu scrim (desktop)
  const catbar = document.querySelector('.mainnav');
  if (catbar) {
    const openMega = () => document.body.classList.add('mega-open');
    const closeMega = () => document.body.classList.remove('mega-open');
    catbar.addEventListener('mouseover', (e) => {
      const li = e.target.closest('li');
      if (li && li.classList.contains('has-mega')) openMega(); else closeMega();
    });
    catbar.addEventListener('mouseleave', closeMega);
    catbar.addEventListener('focusin', (e) => {
      const li = e.target.closest('li');
      if (li && li.classList.contains('has-mega')) openMega();
    });
    catbar.addEventListener('focusout', (e) => {
      if (!catbar.contains(e.relatedTarget)) closeMega();
    });
  }

  // home "favorites" filter pills — filter cards by data-tags
  (function(){
    var grid = document.getElementById('homeFeatured');
    var chips = document.querySelectorAll('.filters .chip');
    if (!grid || !chips.length) return;
    var empty = document.getElementById('filterEmpty');
    var MAX = 12; // cap visible cards per pill, including "All"
    function applyFilter(f){
      var shown = 0;
      grid.querySelectorAll('.prod').forEach(function(card){
        var match;
        if (f === 'all') {
          match = true;
        } else if (f === 'under25') {
          // price-driven so this pill is always accurate (data-price is in cents)
          var price = parseInt(card.getAttribute('data-price') || '0', 10);
          match = price > 0 && price <= 2500;
        } else {
          var tags = (card.getAttribute('data-tags') || '').split(/\s+/);
          match = tags.indexOf(f) !== -1;
        }
        if (match && shown >= MAX) match = false; // cap at MAX cards
        card.style.display = match ? '' : 'none';
        if (match) shown++;
      });
      if (empty) empty.style.display = shown ? 'none' : 'block';
    }
    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.remove('active'); });
        chip.classList.add('active');
        applyFilter(chip.getAttribute('data-filter') || 'all');
      });
    });
    // apply the active filter (default "all") on load so the cap takes effect immediately
    var initial = document.querySelector('.filters .chip.active');
    applyFilter((initial && initial.getAttribute('data-filter')) || 'all');
  })();

  // wishlist — hybrid: localStorage for guests, customer metafield once logged in.
  // Guests get instant local persistence. On login we union(local, account) so
  // nothing saved as a guest is lost, then every change syncs to the account via
  // the app proxy. Server is authoritative for the session once merged.
  (function(){
    var KEY = 'culture_wishlist';
    var CFG = window.__CULTURE_WL__ || { loggedIn:false, server:[], endpoint:'/apps/wishlist' };
    function get(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
    function write(a){ localStorage.setItem(KEY, JSON.stringify(a)); }
    function save(a){ write(a); updateCount(); reflect(); if (CFG.loggedIn) schedulePush(a); }
    function updateCount(){
      var n = get().length;
      document.querySelectorAll('.js-wish-count').forEach(function(s){ s.textContent = n; s.classList.toggle('is-empty', n === 0); });
    }
    function reflect(){
      var w = get();
      document.querySelectorAll('[data-wish]').forEach(function(b){
        var h = b.getAttribute('data-wish'); if (!h) return;
        b.classList.toggle('on', w.indexOf(h) !== -1);
      });
    }
    function toggle(h){
      var w = get(), i = w.indexOf(h);
      if (i === -1) w.push(h); else w.splice(i, 1);
      save(w); return i === -1;
    }

    // --- account sync (logged-in only) -------------------------------------
    var pushTimer = null, lastPushed = null;
    function pushNow(a){
      var body = JSON.stringify({ handles: a });
      if (body === lastPushed) return;          // skip no-op writes
      lastPushed = body;
      fetch(CFG.endpoint + '/sync', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: body, keepalive:true
      }).catch(function(){ lastPushed = null; }); // allow retry on failure
    }
    function schedulePush(a){
      clearTimeout(pushTimer);
      var snapshot = a.slice();
      pushTimer = setTimeout(function(){ pushNow(snapshot); }, 600);
    }
    function union(a, b){
      var out = a.slice();
      (b || []).forEach(function(h){ if (h && out.indexOf(h) === -1) out.push(h); });
      return out;
    }
    function mergeOnLogin(){
      if (!CFG.loggedIn) return;
      var local = get();
      var server = (CFG.server || []).filter(Boolean);
      var merged = union(local, server);
      write(merged);
      // if the guest had items the account didn't, persist the union upstream
      if (merged.length !== server.length) pushNow(merged);
    }

    // delegated so dynamically-injected cards (collection / shop-all grids) work too
    document.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('[data-wish]') : null;
      if (!b) return;
      var h = b.getAttribute('data-wish');
      if (!h || b.classList.contains('wishlist-toggle')) return; // skip the header link
      e.preventDefault();
      b.classList.toggle('on', toggle(h));
    });

    mergeOnLogin();
    updateCount(); reflect();
    window.addEventListener('load', function(){ setTimeout(reflect, 300); });
    window.CultureWishlist = { get: get, reflect: reflect, loggedIn: CFG.loggedIn, server: (CFG.server||[]) };
  })();

  // NOTE: product-card quick-add is handled by cart.js (delegated submit on any
  // /cart/add form -> AJAX add + opens the drawer). The old stub here called
  // preventDefault() and only flashed "Added ✓" without ever adding — removed.

  // scroll reveal
  const els = document.querySelectorAll('.reveal');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const d = (i % 4) * 60;
        setTimeout(() => entry.target.classList.add('in'), d);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin:'0px 0px -6% 0px' });
  els.forEach(el => io.observe(el));

  // hero settle
  window.addEventListener('load', () => {
    const heroImg = document.querySelector('.hero-img img');
    if (heroImg) heroImg.style.transform = 'scale(1)';
  });

/* keep the sticky filter stack aligned to the live header height */
(function(){
  function setHeaderH(){
    var h = document.querySelector('.topbar');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH, { passive:true });
  window.addEventListener('load', setHeaderH);
})();

/* mobile search: icon -> drop-down search panel */
(function(){
  var toggle = document.getElementById('searchToggle');
  var panel  = document.getElementById('searchPanel');
  var scrim  = document.getElementById('searchScrim');
  var close  = document.getElementById('searchClose');
  if (!toggle || !panel) return;
  var input = panel.querySelector('input');
  function open(){
    panel.classList.add('open'); if (scrim) scrim.classList.add('open');
    panel.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true');
    if (input) setTimeout(function(){ input.focus(); }, 120);
  }
  function shut(){
    panel.classList.remove('open'); if (scrim) scrim.classList.remove('open');
    panel.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false');
  }
  toggle.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  if (scrim) scrim.addEventListener('click', shut);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') shut(); });
})();

/* Smile.io rewards: open the panel from "Rewards" links; show points when available */
(function(){
  function openRewards(){
    /* Smile.io official deep-link — opens the panel wherever Smile is mounted (now site-wide) */
    try {
      if (location.hash.replace('#','') === 'smile-home') location.hash = '';
      location.hash = 'smile-home';
      return true;
    } catch(e){ return false; }
  }
  document.querySelectorAll('[data-open-rewards], a[href*="culture-points-rewards"]').forEach(function(a){
    a.addEventListener('click', function(e){ if (openRewards()) e.preventDefault(); });
  });

  function setPoints(){
    var d = window.__smile_ui_customer_data__;
    if (!d) return false;
    var pts = (d.points_balance != null) ? d.points_balance
            : (d.customer && d.customer.points_balance != null) ? d.customer.points_balance
            : (d.points && d.points.balance != null) ? d.points.balance : null;
    if (pts == null) return false;
    document.querySelectorAll('.js-points').forEach(function(s){ s.textContent = pts + ' pts'; });
    return true;
  }
  if (!setPoints()){
    var tries = 0, iv = setInterval(function(){ if (setPoints() || ++tries > 15) clearInterval(iv); }, 1500);
  }
})();
